import axios from "axios";
import authHeader from "./auth-header";
import { toast } from "react-toastify";

export const fetchAllProfilingMaster = (filters = {}) => {
  const query_string = new URLSearchParams(filters).toString();
  return axios
    .get(`${process.env.REACT_APP_BASE_URL}/profiling-master?${query_string}`, {
      headers: authHeader(),
    })
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      toast.error(err?.response?.data?.msg);
      throw err;
    });
};

export const fetchOneProfilingMaster = (id) => {
  return axios
    .get(`${process.env.REACT_APP_BASE_URL}/profiling-master/${id}`, {
      headers: authHeader(),
    })
    .then((res) => {
      return res.data.data;
    })
    .catch((err) => {
      toast.error(err?.response?.data?.msg);
      throw err;
    });
};

export const fetchProfilingMasterByParty = (ps_Id) => {
  return axios
    .get(`${process.env.REACT_APP_BASE_URL}/profiling-master/by-party/${ps_Id}`, {
      headers: authHeader(),
    })
    .then((res) => {
      return res.data.data;
    })
    .catch((err) => {
      // Don't show toast error for 404 (no profiling master found)
      // This is expected behavior for parties without profiling
      if (err?.response?.status !== 404) {
        toast.error(err?.response?.data?.msg);
      }
      throw err;
    });
};

export const createProfilingMaster = (data) => {
  return axios
    .post(`${process.env.REACT_APP_BASE_URL}/profiling-master`, data, {
      headers: authHeader(),
    })
    .then((res) => {
      toast.success(res.data.msg);
      return res.data.data;
    })
    .catch((err) => {
      toast.error(err?.response?.data?.msg);
      throw err;
    });
};

export const updateProfilingMaster = (id, data) => {
  return axios
    .put(`${process.env.REACT_APP_BASE_URL}/profiling-master/${id}`, data, {
      headers: authHeader(),
    })
    .then((res) => {
      toast.success(res.data.msg);
      return res.data.data;
    })
    .catch((err) => {
      toast.error(err?.response?.data?.msg);
      throw err;
    });
};

export const deleteProfilingMaster = (id) => {
  return axios
    .delete(`${process.env.REACT_APP_BASE_URL}/profiling-master/${id}`, {
      headers: authHeader(),
    })
    .then((res) => {
      toast.success(res.data.msg);
      return res.data;
    })
    .catch((err) => {
      toast.error(err?.response?.data?.msg);
      throw err;
    });
}; 